<mat-card class="decoration-card">
    <mat-card-content>

        <mat-toolbar>
            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="add a personal" (click)="createTrailSetup()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <!-- system_setup Column -->
            <ng-container matColumnDef="system_setup">
                <th mat-header-cell *matHeaderCellDef> System Setup </th>
                <td mat-cell *matCellDef="let element"> {{element.system_setup}} </td>
            </ng-container>

            <!-- remark Column -->
            <ng-container matColumnDef="remark">
                <th mat-header-cell *matHeaderCellDef> Remark </th>
                <td mat-cell *matCellDef="let element"> {{element.remark}} </td>
            </ng-container>

            <!-- confirmed Column -->
            <ng-container matColumnDef="confirmed">
                <th mat-header-cell *matHeaderCellDef> Confirmed </th>
                <td mat-cell *matCellDef="let element"> {{element.confirmed_text}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectTrailSetup(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>
